export const DataFields = (t) => {
  return [
    {
      name: "",
      fields: [
        {
          id: "backgroundColorHeader",
          name: t('designmenu_header_form_background_color'),
          type: "color",
          required: true,
          defaultValue: "#000000",
          tooltip: t('designmenu_header_form_background_color_tooltip'),
          size: "small"
        },
        {
          id: "backgroungImageHeader",
          name: t('designmenu_header_form_background_image'),
          type: "image",
          required: true,
          isImage: true,
          defaultValue: "",
          tooltip: t('designmenu_header_form_background_image_tooltip'),
          size: "small"
        }
      ]
    }
  ]
}